var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-pagination',{attrs:{"background":"","layout":"total, prev, pager, next","total":_vm.total,"page-count":_vm.pageCount,"current-page":_vm.currentPage},on:{"current-change":_vm.pageChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }